import { useQuery } from "react-query";

import { RQ_KEY } from "../../constants/query";
import { getUserData } from "../../services/users";
import { TUser } from "../schemas/user";

export default function useQueryUser() {
  return useQuery<TUser, Error>([RQ_KEY.USER], () => getUserData());
}
